import {ReactNode, useMemo} from 'react'
import {Badge} from '../../../../components/badge/Badge'
import {ColorVariant} from '../../../../components/inputs/Button'
import {CustomerModelType} from '../../../../models/CustomerModel'

export interface CustomerTypeBadgeProps {
  customer: {type: CustomerModelType}
  children?: ReactNode
}

export const CustomerTypeBadge = ({customer, children}: CustomerTypeBadgeProps) => {
  const color = useMemo(() => getBadgeColor(customer.type), [customer.type])

  return (
    <Badge uppercase variant={color}>
      {children}
    </Badge>
  )
}

const getBadgeColor = (type: CustomerModelType): ColorVariant => {
  switch (type) {
    case 'customer':
      return 'primary'
    case 'partner':
      return 'info'
    case 'reseller':
      return 'warning'
    default:
      return 'dark'
  }
}
